import dayjs from 'dayjs';
import { Dropdown } from 'react-bootstrap';
import { DateInput } from './DateInput';

export interface Range {
  from: string;
  to: string;
}

const fmt = (d: dayjs.Dayjs) => d.format('YYYY-MM-DD');

export const PRESETS: { label: string; range: () => Range }[] = [
  { label: 'Today', range: () => ({ from: fmt(dayjs()), to: fmt(dayjs()) }) },
  { label: 'Yesterday', range: () => ({ from: fmt(dayjs().subtract(1, 'day')), to: fmt(dayjs().subtract(1, 'day')) }) },
  { label: 'Last 7 days', range: () => ({ from: fmt(dayjs().subtract(6, 'day')), to: fmt(dayjs()) }) },
  { label: 'Last 30 days', range: () => ({ from: fmt(dayjs().subtract(29, 'day')), to: fmt(dayjs()) }) },
  { label: 'This month', range: () => ({ from: fmt(dayjs().startOf('month')), to: fmt(dayjs()) }) },
  { label: 'Last month', range: () => ({ from: fmt(dayjs().subtract(1, 'month').startOf('month')), to: fmt(dayjs().subtract(1, 'month').endOf('month')) }) },
  { label: 'This year', range: () => ({ from: fmt(dayjs().startOf('year')), to: fmt(dayjs()) }) },
];

/** Inclusive from/to date inputs with quick presets. Empty strings mean "no limit". */
export function DateRange({ value, onChange, size = 'sm' }: { value: Partial<Range>; onChange: (r: Range) => void; size?: 'sm' | undefined }) {
  const from = value.from ?? '';
  const to = value.to ?? '';
  return (
    <div className="d-flex flex-wrap align-items-center gap-2">
      <DateInput mode="date" size={size} aria-label="From date" value={from} max={to || undefined} onChange={(v) => onChange({ from: v, to })} style={{ width: 175 }} />
      <span className="text-body-secondary">to</span>
      <DateInput mode="date" size={size} aria-label="To date" value={to} min={from || undefined} onChange={(v) => onChange({ from, to: v })} style={{ width: 175 }} />
      <Dropdown>
        <Dropdown.Toggle size={size} variant="outline-secondary">Presets</Dropdown.Toggle>
        <Dropdown.Menu>
          {PRESETS.map((p) => (
            <Dropdown.Item key={p.label} onClick={() => onChange(p.range())}>{p.label}</Dropdown.Item>
          ))}
          <Dropdown.Divider />
          <Dropdown.Item onClick={() => onChange({ from: '', to: '' })}>Clear</Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
}
